const tabsConfig = {
  tabOptions: {
    tab1: 'billingByMeasureament',
    tab2: 'billingBtContract',
    tab3: 'billingContractMaintenance',
    tab4: 'billingMovimantation'
  },
  tabSelected: 'billingByMeasureament',
  tabsNames: {
    orderByTicket: '',
    orderByContract: '',
    billingContractMaintenance: '',
    ordersByMovimantation: ''
  }
}

export default tabsConfig
